/**
* Simulate a page refresh if you click on the URL of the current page
*/
export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a')

      if (link) {
        const route = useRoute()
      
        const href = link.getAttribute('href')

        if (href === route.path) {
          const loadingIndicator = useLoadingIndicator({
            throttle: 0,
            duration: 100000
          })

          loadingIndicator.clear()
          setTimeout(() => {
            loadingIndicator.start()
            window.scrollTo(0, 0)
      
            setTimeout(() => { 
              loadingIndicator.clear()
            }, 1000)
          }, 1)
        }
      }
    })
  }
})